var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendarChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0a1 1 0 01.993.883L18 1v1h4c1.052 0 1.918.818 1.995 1.851L24 4v18a2.003 2.003 0 01-1.851 1.995L22 24H2a2.003 2.003 0 01-1.995-1.851L0 22V4c0-1.052.818-1.918 1.851-1.995L2 2h4V1A1 1 0 017.993.883L8 1v1h8V1a1 1 0 011-1zM6 4H2v18h20V4h-4v1a1 1 0 01-1.993.117L16 5V4H8v1a1 1 0 01-1.993.117L6 5V4zm10.652 6.242a1 1 0 01.182 1.31l-.076.1-5.155 6a1 1 0 01-1.394.12l-.091-.086-2.845-3.016a1 1 0 011.363-1.458l.091.086 2.083 2.207 4.432-5.157a1 1 0 011.41-.106z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconCalendarChecked;